import { createSlice } from '@reduxjs/toolkit';

import { IState } from 'shared/interfaces/state.interface';
import { initialStore } from '../initial-store';

// Slices

const practitionersSlice = createSlice({
  name: 'practitioners',
  initialState: initialStore.practitioners,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getPractitionersData: (state) => {
      if (!state.isLoading) {
        state.isLoading = true;
      }
    },
    setPractitionersData: (state, { payload }) => {
      state.isLoading = false;
      state.allPractitioners = payload;
    },
    getPractitionersFail: (state) => {
      state.isLoading = false;
    }
  }
});

export const {
  getPractitionersData,
  setPractitionersData,
  getPractitionersFail
} = practitionersSlice.actions;

export const { reducer } = practitionersSlice;

// Selectors
export const getAllPractitionersSelector = (state: IState) =>
  state && state.practitioners.allPractitioners;

export const getPractitionersLoadingSelector = (state: IState) =>
  state && state.practitioners.isLoading;
